<template>
  <v-card style='text-align:left'>

    <v-layout row v-if="!person.fate || (person.fate.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Wartime Fate</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringCodeProp("fate", "ft", "Returned to Australia")'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Wartime Fate</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2>
        <v-select v-focus autofocus solo v-model="person.fate[0].id" :items="$constants.codeValues.ft" item-text="v" item-value="id">
        </v-select>
        <!--
        <v-radio-group v-model="person.fate[0].id" row> 
          <v-radio  v-for="fateCode in $constants.codeValues.ft" v-bind:key="fateCode.id" :label="fateCode.v"
            :value="fateCode.id">
          </v-radio>
        </v-radio-group>
        -->
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("fate")' >delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> 

    <v-layout row v-if="!person.fatePostWar || (person.fatePostWar.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Postwar Fate</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringCodeProp("fatePostWar", "ftp", "Died from war-related injury")'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Postwar Fate</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2>
        <v-select v-focus autofocus solo v-model="person.fatePostWar[0].id" :items="$constants.codeValues.ftp" item-text="v" item-value="id">
        </v-select>
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("fatePostWar")' >delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> 

    <v-layout row v-if="!person.deathDate">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Death Date</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("deathDate", "1940-01-31")'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Death Date</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2 mt-3>
          <EditDateMaybeRange v-bind:container='person' v-bind:dateProp="'deathDate'"/>
          <!-- input type="date" v-model="person.deathDate"/ --> 
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("deathDate")' >delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> 

    <v-layout row v-if="!person.ageAtDeath">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Age at Death</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("ageAtDeath", "99")'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Age at Death</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2 mt-3>
          <input type="number" v-focus autofocus v-model="person.ageAtDeath" min="14" max="120"/> 
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("ageAtDeath")' >delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> 

    <v-layout row v-if="!person.honourRollPlace">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Honour Roll Place</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("honourRollPlace", {rid: -1})'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Honour Roll Place</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2>
        <v-autocomplete v-focus autofocus v-model="hrp.select" :items="hrp.places" item-text="pn" item-value="id"
          :search-input.sync="hrpSearch" :loading="hrp.loading" single-line  return-object  @change="hrpChange()">     
        </v-autocomplete>
        <v-layout row v-if="person.honourRollPlace.extra">
          <v-flex xs10>
              <v-text-field v-model="person.honourRollPlace.extra" label="Street/Locality"/>
          </v-flex>
          <v-flex xs2>
              <v-icon  small  @click='delPlaceExtra("honourRollPlace")' >delete</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("honourRollPlace")'>delete</v-icon>
        <v-icon v-if="(!person.honourRollPlace.extra)"  small  @click='addPlaceExtra("honourRollPlace")'>place</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row v-if="!person.awmHonourRollPanel">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>AWM Roll of Honour Panel</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("awmHonourRollPanel", " ")'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>AWM Roll of Honour Panel</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2 mt-3>
           <v-text-field v-focus autofocus v-model="person.awmHonourRollPanel" size="20"/> 
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("awmHonourRollPanel")' >delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>     

<!--
    <v-layout row v-if="!person.burial">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Burial</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("burial", {rid: -1, graveRef: "", cemetery: { id: -1, name: "" }})'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Burial</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row>         
          <v-flex xs8 mx-2><v-text-field v-focus autofocus v-model="person.burial.graveRef" label="Grave reference (optional)" /></v-flex>        
        </v-layout>
        <v-layout row>
          <v-flex xs8 mx-2>
            <v-autocomplete v-model="cemetery.select" :items="cemetery.cemeteries" item-text="n" item-value="id" label="Search for a cemetery"
                :search-input.sync="cemeterySearch" :loading="cemetery.loading" single-line return-object @change="cemeteryChange()">
            </v-autocomplete>
          </v-flex>
          <v-flex xs4 pt-3>       
            <v-icon  small  @click='delProp("burial")'>delete</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> -->

    <v-layout row v-if="!person.burial || (person.burial.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Burial</label><v-btn flat fab  small mt-4  middle 
        @click='addMultiOccuringProp("burial", -1, {graveRef: "", cemetery: { id: -1, name: "" }})'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>Burial</label>
      </v-flex>
      <v-flex xs10>
        <v-layout column justify-start v-for="(burial, index) in person.burial" v-bind:key="index">  <!-- "burial.rid"> -->
          <v-flex xs12 >
            <v-layout>
              <v-flex xs12>
                <v-layout row>
                  <v-flex xs8 mx-2>
                    <v-text-field v-focus autofocus v-model="burial.graveRef" label="Grave reference (optional)" />
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs8 mx-2>
                    <EditCemetery v-bind:cemetery='burial.cemetery' v-bind:person='person' v-bind:ix='index'/>
                    <!--
                    <v-autocomplete v-model="cemetery.select" :items="cemetery.cemeteries" item-text="n" item-value="cemetery.id"
                     label="Search for a cemetery" :search-input.sync="cemeterySearch" :loading="cemetery.loading" 
                     single-line return-object @change="cemeteryMultiChange(index)">
                    </v-autocomplete>
                    -->
                  </v-flex>

                  <v-flex xs4 pt-3>
                    <v-icon  small  @click='delProp("burial", index)' >delete</v-icon>
                    <v-icon  small @click='addMultiOccuringProp("burial", index, {graveRef: "", cemetery: { id: -1, name: "" }})'>add</v-icon>
                    <v-icon v-if="index > 0"  small   @click='up(person.burial, index)'>arrow_upward</v-icon>
                    <v-icon v-if="index < (person.burial.length - 1)"  small  @click='down(person.burial, index)'>arrow_downward</v-icon>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>     

  </v-card>
</template>        

<script>

// import CemeteryService from "@/services/CemeteryService" ;
import EditCemetery from "./EditCemetery" ;
import PlaceService from "@/services/PlaceService" ;
import EditDateMaybeRange from "./EditDateMaybeRange" ; 

export default {
  components: { EditCemetery, PlaceService, EditDateMaybeRange },
  // components: {CemeteryService, PlaceService, EditDateMaybeRange },

  props: {
    person: null
  },

  data () {
    return {
      /*
      cemetery: {
        select: {id: -1, n: ""}, 
        cemeteries: [],
        loading: false,
        origId: -1,
        nextSearchFor: null
      },
      cemeterySearch: null,
      */
      addSeqForRid:-1,
      hrp: {
        select: {id: -1, pn: ""}, 
        places: [],
        loading: false,
        origId: -1,
        placeRelType: 'ph',
        nextSearchFor: null
      },
      hrpSearch: null         
    }
  },

  watch: {
    async cemeterySearch (val) {
      if (val && val !== this.cemetery.select.n && (val.length >= 2)) {
        this.cemetery.select.id = -1 ;
        this.runCemeterySearch(val, this.cemetery) ;
      }
    },

    async hrpSearch (val) {
      console.log("IN HRP SEARCH val: " + val + ", this.hrpSelect.pn=" + this.hrp.select.pn) ;
      if (val && val !== this.hrp.select.pn && (val.length >= 2)) {
        this.error = this.$placeQuerySelections(val, this.hrp) ;
      }
    },    
    
    person: function (val) { // TODO
      // TO DO this.updateCemetery(this.cemetery, this.person.burial) ;
      this.$updatePlaceSelectionFromRecord(this.hrp, this.person.honourRollPlace) ;
    }    
  },

  methods: {

    updateCemetery (locp, dbp) {

      if (dbp && dbp.cemetery) {
        const cem = dbp.cemetery ;
        locp.select.id = cem.id ; 
        locp.select.n = cem.name ;
        if (cem.place) {
          const cemPlace = cem.place ;
          if (cemPlace.town) locp.select.n += ", " + cemPlace.town.v ;
          if (cemPlace.state) locp.select.n += ", " + cemPlace.state.v ;
          if (cemPlace.country) locp.select.n += ", " + cemPlace.country.v ;
        }
      }
      else {
        locp.select.id = -1 ; 
        locp.select.n = "" ; 
      }
      locp.origId =  locp.select.id ;
      locp.cemeteries = [ locp.select ] ;
      console.log("Set updateCemetery locp=" + JSON.stringify(locp)) ;
    },

    finaliseUpdates () {
    },
    /*
    async cemeteryChange () {
      console.log("---------------------------------cemeteryChange: " + JSON.stringify(this.cemetery.select)) ;
      this.person.burial.cemetery.newId = this.cemetery.select.id ;
    },    

    async cemeteryMultiChange (ix) {
      console.log("---------------------------------cemeteryMultiChange for ix " + ix + ": " + JSON.stringify(this.cemetery.select)) ;
      this.person.burial[ix].cemetery.newId = this.cemetery.select.id ;
    },

    async runCemeterySearch (val, locp) {

      console.log("runCemeterySearch val: " + val) ;
      if (locp.loading) {
        locp.pendingSearch = val ;
        console.log("PENDING SEARCH QUEUED: " + val) ;
        return ;
      }
      locp.loading = true ;
      try {
        const response = await CemeteryService.findMatchesOnName(val, "count") ;
        console.log("CemeteryService responsed") ; // + JSON.stringify(response)) ;
        for (var c of response.data) c.n += " [" + c.c + "]" ;
        locp.cemeteries = response.data ;
      }
      catch (err) {
        console.log("runCemeterySearch catch err:" + JSON.stringify(err)) ;
        this.error = err.response.data.error  ;
      }
      finally {
        locp.loading = false ;
        if (locp.pendingSearch) {
          const queuedSearch = locp.pendingSearch ;
          locp.pendingSearch = null ;
          console.log("Queuing pending search.." + queuedSearch) ;
          this.runCemeterySearch(queuedSearch, locp) ;
        }
      }
    },
    */
    async hrpChange () {
      console.log("---------------------------------hrpChange: " + JSON.stringify(this.hrp.select)) ;
      this.person.honourRollPlace.newId = this.hrp.select.id ;
    },

    needed (value) {
      console.log(" in needed, value is " + value)  ;
      if (value && value.length && (value.length > 0)) return true ;
      this.$emit('errorOnTab') ; 
      console.log("emmitted swap") ;
      return "Required" ;
    },

    addMultiOccuringProp (propName, index, record, propCode, defaultValue) {  // addMultiOccuringProp("otherNames", -1, {surname: "", firstNames: ""})

      if (!this.person[propName]) this.person[propName] = [] ;
      var newRec ;
      if (record) newRec = { ...record, rid: this.addSeqForRid-- } ; // a unique rid so as not to confuse keys - but it will be negative, so backend knows it is new
      else  {
        newRec = {...this.setDefaultOption(propCode, defaultValue), rid: this.addSeqForRid--} ;
      }

      console.log("in addMultiOccuringProp " + record + " newRec " + JSON.stringify(newRec)) ;

      this.person[propName].splice(index + 1, 0, newRec) ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    addDateRange (propName, index) {
      console.log("adding date range to " + propName + " at " + index) ;
      this.person[propName][index].scopeFrom = "1900-01-01" ;
      this.person[propName][index].scopeTo = "1900-12-31" ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    delDateRange (propName, index) {
      console.log("adding date range to " + propName + " at " + index) ;
      delete this.person[propName][index].scopeFrom  ;
      delete this.person[propName][index].scopeTo ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    addPlaceExtra (propName) {
      console.log("adding placeextra to " + propName) ;
      this.person[propName].extra = " " ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    delPlaceExtra (propName) {
      console.log("adding placeextra to " + propName) ;
      delete this.person[propName].extra ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },    

    up (arr, ix) {  // take entry at ix and move it to ix-1
      console.log("UpA " + ix + "  arr:" + JSON.stringify(this.person.otherNames)) ; 
      var x = arr[ix] ;
      arr[ix] = arr[ix - 1] ;
      arr[ix - 1] = x ;
      console.log("UpB " + ix + "  arr:" + JSON.stringify(this.person.otherNames)) ; 
      this.$forceUpdate() ;

    },
    down (arr, ix) {
      console.log("downA " + ix + "  arr:" + JSON.stringify(arr)) ; 
      var x = arr[ix] ;
      arr[ix] = arr[ix + 1] ;
      arr[ix + 1] = x ;
      console.log("downB " + ix + "  arr:" + JSON.stringify(arr)) ; 
      this.$forceUpdate() ;
    },

    setDefaultOption (codeType, defaultValue) {
      const glist = this.$constants.codeValues[codeType] ; 
      for (var i = 0 ; i < glist.length ; i++) {
        if (glist[i].v === defaultValue) {
          console.log("SETTING def value for " + codeType + " :  " + JSON.stringify({ v: glist[i].v, id: glist[i].id })) ;
          return { v: glist[i].v, id: glist[i].id } ;
        }
      }
      return { v: "No default", id: -1 } ;
    },

    delProp (propName, index) {
      console.log("Del prop name " + propName + " index " + index) ;
      if (index >= 0) {
        console.log("before: " + JSON.stringify(this.person[propName])) ;
        this.person[propName].splice(index, 1) ;
        console.log("after : " + JSON.stringify(this.person[propName])) ;
      }
      else delete this.person[propName] ;
      this.$forceUpdate() ;
    },

    addSinglyOccuringNoncodeProp (propName, defaultValue) {
      this.person[propName] = defaultValue ;
      this.$forceUpdate() ;   // shouldnt have to do this..
    },

    addSinglyOccuringCodeProp (propName, propCode, defaultValue) {  
      this.person[propName] = [ this.setDefaultOption(propCode, defaultValue) ] ;
      this.$forceUpdate() ;   // shouldnt have to do this..
    }
  } 
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Person/FatePostwarTab.vue